import React, { useEffect,useState } from "react";
import unsplash from "../api/unsplash";
import { useLocation } from "react-router";
import { CAccordion,CRow,CFormLabel,CCol,CContainer,CToastHeader ,CToast,CToastBody,CToastClose,CAccordionItem,CAccordionHeader,CAccordionBody,CFormSelect,CFormInput,CTable,CTableRow,CTableBody,CTableHeaderCell,CTableDataCell,CTableHead,CForm,CButton ,CFormTextarea } from '@coreui/react'
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Select  from '@mui/material/Select';
import IconButton from '@mui/material/IconButton';
import "../style/style.css"
import Modal from "./MyModal";
import Dropdown from 'react-dropdown';
import Toast from './Toast';
import 'react-dropdown/style.css'

import { } from '@coreui/react'
import { FormControlUnstyledContext } from "@mui/material";




class Checklist extends React.Component {




  handleClick = (e) => {
  e.preventDefault();
  console.log(this.state.arrayIndex);
   console.log(this.rischio.value);
   console.log(this.state.arrayIndex);
 }

 setIndexArray = (x) =>{

  this.setState({ arrayIndex: x })
}


handleCboxChange=(e,posizione) => {
//per gestire le firme con i check. Se vuoto inizializzo con stringa con tutti 0-0-0-0


let currentChoiches = this.state.vdrDocValutazione;

if (currentChoiches[3][e.target.name]===""){

  currentChoiches[3][e.target.name] = "0-0-0-0";

  var temp = currentChoiches[3][e.target.name].split("-");
  e.target.checked?temp[posizione]=1:temp[posizione]=0;

  currentChoiches[3][e.target.name] = temp[0]+"-"+temp[1]+"-"+temp[2]+"-"+temp[3];


}else {
  var temp = currentChoiches[3][e.target.name].split("-");
  e.target.checked?temp[posizione]=1:temp[posizione]=0;

  currentChoiches[3][e.target.name] = temp[0]+"-"+temp[1]+"-"+temp[2]+"-"+temp[3];

}

this.setState()
e.target.checked = true;
this.setState({ vdrDocValutazione: currentChoiches});


}


handleChangeDpi= (e) =>{

  this.setState({dpi: typeof e.target.value === 'string' ? e.target.value.split(',') : e.target.value})

}


 handleChangeData = (x,e,tipo,name) => {

  this.setState({ arrayIndex: x })

switch(tipo){

  case "Cliente":
 
    let clienteAttuale = this.state.cliente;


    if(typeof name != "undefined"){
      clienteAttuale[name] = e.value;
    }else{
      let {name: fieldName, value} = e.target;
      clienteAttuale[fieldName] = value;
    }
  break;


  case "DatiAziendali":
 
    let azienda = this.state.daDatiAziendali[x];


    if(typeof name != "undefined"){
      azienda[name] = e.value;
    }else{
      let {name: fieldName, value} = e.target;
      azienda[fieldName] = value;
    }
  break;



  case "Struttura":
    
 
 let struttura = this.state.adlStruttura[x];


if(typeof name != "undefined"){
  struttura[name] = e.value;
}else{
  let {name: fieldName, value} = e.target;
  struttura[fieldName] = value;
}
    break;

  case "Emergenza":

        let emergenza = this.state.adlEmergenza[x];

        if(typeof name != "undefined"){
          emergenza[name] = e.value;
        }else{

          let {name: fieldName, value} = e.target;
          emergenza[fieldName] = value;
        }

  break;

  case "Formazione":

        let formazione = this.state.formzFormazione[x];
        console.log(formazione);
       if(typeof name != "undefined"){
        formazione[name] = e.value;
       }else{
       
         let {name: fieldName, value} = e.target;
       
         formazione[fieldName] = value;
       }
       console.log(formazione);
             break;


  case "Ambienti":

        let ambiente = this.state.dtAmbienti[x];
  
       if(typeof name != "undefined"){
        ambiente[name] = e.value;
       }else{
       
         let {name: fieldName, value} = e.target;
       
         ambiente[fieldName] = value;
       }
      
  break;


  case "Attrezzature":

        let attrezzatura = this.state.dtAttrezzature[x];
  
       if(typeof name != "undefined"){
        attrezzatura[name] = e.value;
       }else{
       
         let {name: fieldName, value} = e.target;
       
         attrezzatura[fieldName] = value;
       }
      
  break;

  case "Impianti":

    let impianto = this.state.dtImpianti[x];

   if(typeof name != "undefined"){
    impianto[name] = e.value;
   }else{
   
     let {name: fieldName, value} = e.target;
   
     impianto[fieldName] = value;
   }
  
  break;
  
  case "DocumentoValutazione":

    let documento = this.state.vdrDocValutazione[x];

   if(typeof name != "undefined"){
    documento[name] = e.value;
   }else{
   
     let {name: fieldName, value} = e.target;
   
     documento[fieldName] = value;
   }
  
  break;
  case "Rischi":

    let rischio = this.state.vdrRischi[x];

   if(typeof name != "undefined"){
    rischio[name] = e.value;
   }else{
   
     let {name: fieldName, value} = e.target;
   
     rischio[fieldName] = value;
   }
  
  break;

}




 
}

inputFromCBoxModal = async (dpiSelezionati,name,index) => {


let tempDpi ="";

for(let i=0;i<dpiSelezionati.length;i++){

tempDpi +=dpiSelezionati[i];

if(i+1 !== dpiSelezionati.length){
  tempDpi+="-"
}
}
console.log(tempDpi);
let vdrTemp = this.state.vdrRischi;

vdrTemp[index][name] = tempDpi;
console.log(vdrTemp[index][name]);
this.setState({vdrRischi:vdrTemp})

let i;
try {
for(i=0;i<this.state.vdrRischi.length;i++){
  unsplash
  .put('vdrRischi',{auth :"a5d42c3ed7977afa2d8e922569e7940b",rischio:this.state.vdrRischi[i]},
  { headers: {
    'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
  }}  );
}


alert("Salvataggio effettuato")
}catch{

}



}


editFromModal = async(data,tipologia) =>{
console.log(data)
  switch(tipologia){
    case "Attrezzature":
      let attrezzatura = {
        Attrezzatura:data[0].val,
        Ubicazione:data[1].val,
        Mansione:data[2].val,
        Libretto:data[3].val,
        Marcatura_CE:data[4].val,
        Note:data[5].val,
        ID:data[6].val,
        ID_Checklist:this.state.idChecklist,
      }
      const responseputAttrezzature=  await unsplash
      .put('adlAttrezzature',{auth :"a5d42c3ed7977afa2d8e922569e7940b",attrezzatura:attrezzatura} ,
      { headers: {
        'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
      }} );

      const responseGetAttrezzature=  await unsplash
            .get('adlAttrezzature',{ headers: {
              'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
            },params:{id:this.state.idChecklist}}
             );
       
       
            this.setState({ adlAttrezzature: responseGetAttrezzature.data.data  });
            

            alert("salvataggio effettuato")
    break;

    case "LuoghiDiLavoro":
      let luogo = {
        Reparto:data[0].val,
        Mansione:data[1].val,
        Descrizione:data[2].val,
        Compatile_Gravidanza:data[3].val,
        Note:data[4].val,
        ID:data[5].val,
        idChecklist:this.state.idChecklist,
      }
      console.log(luogo) 
      const responseputLuogo=  await unsplash
      .put('adlLuoghiLavoro',{auth :"a5d42c3ed7977afa2d8e922569e7940b",luogo:luogo} ,
      { headers: {
        'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
      }} );

      const responseGetLuogo=  await unsplash
            .get('adlLuoghiLavoro',{ headers: {
              'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
            },params:{id:this.state.idChecklist}}
             );
       
       
            this.setState({ adlLuoghiLavoro: responseGetLuogo.data.data  });
          

            alert("salvataggio effettuato")
    break;
          }

          



}

inputFromModal = async(data,tipologia) =>{
switch(tipologia){
case "LuoghiDiLavoro":
  let luogo = {
    Reparto:data[0].val,
    Mansione:data[1].val,
    Descrizione:data[2].val,
    Compatile_Gravidanza:data[3].val,
    Note:data[4].val,
    idChecklist:this.state.idChecklist,
  }
  console.log(luogo);
  const responsePutLuoghiLavoro = await unsplash.post('adlLuoghiLavoro',{auth : "a5d42c3ed7977afa2d8e922569e7940b",luogo:luogo},
  { headers: {
    'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
  }});

  const responseLuoghiLavoro =  await unsplash
        .get('adlLuoghiLavoro',{ headers: {
          'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
        } ,params:{id:this.state.idChecklist}});

  const responseRischi = await unsplash.post('vdrRischi',{auth : "a5d42c3ed7977afa2d8e922569e7940b",idChecklist:luogo.idChecklist,mansione:luogo.Mansione},
        { headers: {
          'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
        }}  );  

        const responsegetRischi =  await unsplash
        .get('vdrRischi', { headers: {
          'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
        },params:{id:this.state.idChecklist}}
        );
   
        this.setState({ vdrRischi: responsegetRischi.data.data });
        console.log(responsegetRischi.data.data );
      



   
  this.setState({ adlLuoghiLavoro: responseLuoghiLavoro.data.data });
  console.log(luogo);
  var mansioniAttuali = this.state.mansioni;
  mansioniAttuali.push(luogo.Mansione);
  this.setState({mansioni:mansioniAttuali});


  break;
case "Addestramento":
  let addestramento = {
    Mansione:data[0].val,
    Addestramento:data[1].val,
    Note:data[2].val,
    Data_Addestramento:data[3].val,
    ID_Checklist:this.state.idChecklist,
  }
  const responseAddestramento = await unsplash.post('formzAddestramento',{auth : "a5d42c3ed7977afa2d8e922569e7940b",addestramento:addestramento},
  { headers: {
    'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
  }}  );
  const responseGetAddestramento=  await unsplash
        .get('formzAddestramento',{ headers: {
          'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
        },params:{id:this.state.idChecklist}}
         );
   
        this.setState({ formzAddestramento: responseGetAddestramento.data.data });
break;

case "Attrezzature":
  console.log(data)
  let attrezzatura = {
    Attrezzatura:data[0].val,
    Ubicazione:data[1].val,
    Mansione:data[2].val,
    Libretto:data[3].val,
    Marcatura_CE:data[4].val,
    Note:data[5].val,
    ID_Checklist:this.state.idChecklist,
  }
  const responseAttrezzature = await unsplash.post('adlAttrezzature',{auth : "a5d42c3ed7977afa2d8e922569e7940b",attrezzatura:attrezzatura},
  { headers: {
    'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
  }}  );
  const responseGetAttrezzature=  await unsplash
        .get('adlAttrezzature',{ headers: {
          'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
        },params:{id:this.state.idChecklist}}
         );
   
        this.setState({ adlAttrezzature: responseGetAttrezzature.data.data });
break;



}
}


setVisible = (b) =>{
  console.log(b);
  this.state.visMod = b;
  console.log(this.state.visMod);
}



loadData = async(tipo) => {
  //qua fare un if che se è già caricato non devo ricaricare ancora se no non ha senso 
  switch(tipo){
    case "DatiAziendali":
      if(this.state.daDatiAziendali.length == 0){
        const responseAziendali =  await unsplash
          .get('daDatiAziendali',{ headers: {
            'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
          },params:{id:this.state.idChecklist}}
           );
          this.setState({ daDatiAziendali: responseAziendali.data.data });
     
        }

    break;




    case "AmbientiDiLavoro" :
  if(this.state.adlStruttura.length == 0){
  const responseStruttura =  await unsplash
    .get('adlStrutture',{ headers: {
      'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
    },params:{id:this.state.idChecklist}},
     );
    this.setState({ adlStruttura: responseStruttura.data.data });

  }
  if(this.state.adlEmergenza.length == 0){
    const responseEmergenza =  await unsplash
      .get('adlEmergenza', { headers: {
        'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
      },params:{id:this.state.idChecklist}},
      );
     
      this.setState({ adlEmergenza: responseEmergenza.data.data });
   
    }
    if(this.state.adlLuoghiLavoro.length == 0){
      const responseLuoghiLavoro =  await unsplash
        .get('adlLuoghiLavoro', { headers: {
          'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
        },params:{id:this.state.idChecklist}},
        );
   
        this.setState({ adlLuoghiLavoro: responseLuoghiLavoro.data.data });
    
      }
      if(this.state.adlAttrezzature.length == 0){
        const responseAttrezzature =  await unsplash
          .get('adlAttrezzature', { headers: {
            'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
          },params:{id:this.state.idChecklist}},
          );
     
          this.setState({ adlAttrezzature: responseAttrezzature.data.data });
      
        }
      break;
      case "Formazione" :
        if(this.state.formzFormazione.length == 0){
          const responseLuoghiLavoro =  await unsplash
            .get('formzFormazione',{ headers: {
              'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
            },params:{id:this.state.idChecklist}}
             );
       
            this.setState({ formzFormazione: responseLuoghiLavoro.data.data });
         
          }
          if(this.state.formzAddestramento.length == 0){
            const responseLuoghiLavoro =  await unsplash
              .get('formzAddestramento', { headers: {
                'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
              },params:{id:this.state.idChecklist}}
              );
         
              this.setState({ formzAddestramento: responseLuoghiLavoro.data.data });
     
            }

      break;

      case "DocumentazioneTecnica":
        if(this.state.dtAmbienti.length == 0){
          const responseAmbienti =  await unsplash
            .get('dtAmbienti',{ headers: {
              'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
            } ,params:{id:this.state.idChecklist}}
            );
       
            this.setState({ dtAmbienti: responseAmbienti.data.data });
         
          }
          if(this.state.dtAttrezzature.length == 0){
            const responseAttrezzature =  await unsplash
              .get('dtAttrezzature', { headers: {
                'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
              },params:{id:this.state.idChecklist}}
              );
         
              this.setState({ dtAttrezzature: responseAttrezzature.data.data });

            }
            if(this.state.dtImpianti.length == 0){
              const responseImpianti =  await unsplash
                .get('dtImpianti',{ headers: {
                  'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
                },params:{id:this.state.idChecklist}}
                 );
           
                this.setState({ dtImpianti: responseImpianti.data.data });
  
              }
      break;

      case "ValutazioneDeiRischi":

        if(this.state.vdrDocValutazione.length == 0){
          const responseDocValutazione =  await unsplash
            .get('vdrDocValutazione',{ headers: {
              'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
            },params:{id:this.state.idChecklist}}
             );
       
            this.setState({ vdrDocValutazione: responseDocValutazione.data.data });
         
          }
          if(this.state.vdrRischi.length == 0){
            const responseRischi =  await unsplash
              .get('vdrRischi', { headers: {
                'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
              },params:{id:this.state.idChecklist}}
              );
         
              this.setState({ vdrRischi: responseRischi.data.data });
              console.log(responseRischi.data.data );
            }
    

        if(this.state.dpi.length == 0){
          const responseDpi=  await unsplash
            .get('dpi', { headers: {
              'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
            },params:{id:this.state.idChecklist}}
            );
       
            this.setState({ dpi: responseDpi.data.data });
            console.log(responseDpi.data.data );
          }
      break;





    }
}


deleteData =async (rowId,mansione,tipo)=>{


  switch(tipo){
case "luogoDiLavoro":
  const responseDeleteLuoghiLavoro = await unsplash
  .delete('adlLuoghiLavoro',
  { headers: {
    'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
  },
    data: {
      id: rowId
    
  }


});

const responseDeleteRischi = await unsplash
.delete('vdrRischi',
{ headers: {
  'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
},
  data: {
    idChecklist: this.state.idChecklist,
    Mansione:mansione
  
}


});

 const responseRischi =  await unsplash
              .get('vdrRischi', { headers: {
                'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
              },params:{id:this.state.idChecklist}}
              );
         
              this.setState({ vdrRischi: responseRischi.data.data });
              console.log(responseRischi.data.data );
            


  const responsegetLuoghiLavoro =  await unsplash
        .get('adlLuoghiLavoro',{ headers: {
          'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
        } ,params:{id:this.state.idChecklist}});
   
  this.setState({ adlLuoghiLavoro: responsegetLuoghiLavoro.data.data });

  var i;
  var mansioniAttuali = [];
  for(i=0;i<this.state.adlLuoghiLavoro.length;i++){
    mansioniAttuali.push(this.state.adlLuoghiLavoro[i].Mansione)
  }
  this.setState({mansioni : mansioniAttuali});
 
  alert("Mansione eliminata correttamente");
  break;

  case "Addestramento":

    const responseDeleteAddestramento = await unsplash
    .delete('formzAddestramento',
    { headers: {
      'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
    },
      data: {
        id: rowId
      
    }
  });
  
  
  
  
    const responsegetAddestramento =  await unsplash
          .get('formzAddestramento',{ headers: {
            'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
          } ,params:{id:this.state.idChecklist}});
     
          this.setState({ formzAddestramento: responsegetAddestramento.data.data });

    alert("Mansione eliminata correttamente");
    break;
    case "Attrezzature":

      const responseDeleteAttrezzature = await unsplash
      .delete('adlAttrezzature',
      { headers: {
        'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
      },
        data: {
          id: rowId
        
      }
    });
    
    
    
    
      const responsegetAttrezzature =  await unsplash
            .get('adlAttrezzature',{ headers: {
              'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
            } ,params:{id:this.state.idChecklist}});
       
            this.setState({ adlAttrezzature: responsegetAttrezzature.data.data });
  
      alert("Attrezzatura eliminata correttamente");
      break;


  }


}



updateData = (e,type) => {


switch (type){

  case "Cliente":
    unsplash.post('updateClienti',{auth : "a5d42c3ed7977afa2d8e922569e7940b",cliente:this.state.cliente,idChecklist:this.state.idChecklist},
    { headers: {
      'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
    }}  )
    .then(res => {
        console.log("ok");

      })

  break;
  case "DatiAziendali":
    const responseFirstAziendali =  unsplash
  .put('daDatiAziendali',{auth :"a5d42c3ed7977afa2d8e922569e7940b",azienda:this.state.daDatiAziendali[0]} ,
  { headers: {
    'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
  }} );
  const responseSecondAziendali =  unsplash
  .put('daDatiAziendali',{auth :"a5d42c3ed7977afa2d8e922569e7940b",azienda:this.state.daDatiAziendali[1]},
  { headers: {
    'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
  }}  );
    break;




  case "Struttura":
    const responseFirstStruttura =  unsplash
  .put('adlStrutture',{auth :"a5d42c3ed7977afa2d8e922569e7940b",struttura:this.state.adlStruttura[0]},
  { headers: {
    'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
  }}  );
  const responseSecondStruttura =  unsplash
  .put('adlStrutture',{auth :"a5d42c3ed7977afa2d8e922569e7940b",struttura:this.state.adlStruttura[1]},
  { headers: {
    'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
  }}  );
    break;
  case "Emergenza":

    const responseFirstEmergenza=  unsplash
  .put('adlEmergenza',{auth :"a5d42c3ed7977afa2d8e922569e7940b",emergenza:this.state.adlEmergenza[0]} ,
  { headers: {
    'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
  }} );
  const responseSecondEmergenza =  unsplash
  .put('adlEmergenza',{auth :"a5d42c3ed7977afa2d8e922569e7940b",emergenza:this.state.adlEmergenza[1]},
  { headers: {
    'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
  }}  );
    break;

    case "Formazione":

      const responseFirstFormazione=  unsplash
    .put('formzFormazione',{auth :"a5d42c3ed7977afa2d8e922569e7940b",formazione:this.state.formzFormazione[0]},
    { headers: {
      'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
    }}  );
    const responseSecondFormazione =  unsplash
    .put('formzFormazione',{auth :"a5d42c3ed7977afa2d8e922569e7940b",formazione:this.state.formzFormazione[1]},
    { headers: {
      'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
    }}  );
      break;

      case "Ambienti":

        const responseFirstAmbienti=  unsplash
      .put('dtAmbienti',{auth :"a5d42c3ed7977afa2d8e922569e7940b",ambiente:this.state.dtAmbienti[0]},
      { headers: {
        'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
      }}  );
      const responseSecondAmbienti =  unsplash
      .put('dtAmbienti',{auth :"a5d42c3ed7977afa2d8e922569e7940b",ambiente:this.state.dtAmbienti[1]},
      { headers: {
        'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
      }}  );
        break; 
    case "Attrezzature":

          const responseFirstAttrezzature=  unsplash
        .put('dtAttrezzature',{auth :"a5d42c3ed7977afa2d8e922569e7940b",attrezzatura:this.state.dtAttrezzature[0]},
        { headers: {
          'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
        }}  );
        const responseSecondAttrezzature =  unsplash
        .put('dtAttrezzature',{auth :"a5d42c3ed7977afa2d8e922569e7940b",attrezzatura:this.state.dtAttrezzature[1]},
        { headers: {
          'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
        }}  );
    break; 
    case "Impianti":

          const responseFirstImpianti=  unsplash
        .put('dtImpianti',{auth :"a5d42c3ed7977afa2d8e922569e7940b",impianto:this.state.dtImpianti[0]},
        { headers: {
          'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
        }}  );
        const responseSecondImpianti =  unsplash
        .put('dtImpianti',{auth :"a5d42c3ed7977afa2d8e922569e7940b",impianto:this.state.dtImpianti[1]},
        { headers: {
          'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
        }}  );
        const responseThirdImpianti =  unsplash
        .put('dtImpianti',{auth :"a5d42c3ed7977afa2d8e922569e7940b",impianto:this.state.dtImpianti[2]},
        { headers: {
          'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
        }}  );
    break;   
    case "DocumentoValutazione":

      const responseFirstDocumento=  unsplash
    .put('vdrDocValutazione',{auth :"a5d42c3ed7977afa2d8e922569e7940b",docValutazione:this.state.vdrDocValutazione[0]},
    { headers: {
      'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
    }}  );
    const responseSecondDocumento =  unsplash
    .put('vdrDocValutazione',{auth :"a5d42c3ed7977afa2d8e922569e7940b",docValutazione:this.state.vdrDocValutazione[1]},
    { headers: {
      'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
    }}  );
    const responseThirdDocumento=  unsplash
    .put('vdrDocValutazione',{auth :"a5d42c3ed7977afa2d8e922569e7940b",docValutazione:this.state.vdrDocValutazione[2]},
    { headers: {
      'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
    }}  );
    const responseFourthDocumento =  unsplash
    .put('vdrDocValutazione',{auth :"a5d42c3ed7977afa2d8e922569e7940b",docValutazione:this.state.vdrDocValutazione[3]},
    { headers: {
      'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
    }}  );
    const responseFifthDocumento =  unsplash
    .put('vdrDocValutazione',{auth :"a5d42c3ed7977afa2d8e922569e7940b",docValutazione:this.state.vdrDocValutazione[4]},
    { headers: {
      'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
    }}  );
    const responseSixthDocumento =  unsplash
    .put('vdrDocValutazione',{auth :"a5d42c3ed7977afa2d8e922569e7940b",docValutazione:this.state.vdrDocValutazione[5]},
    { headers: {
      'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
    }}  );
    
break; 
case "Rischi":
console.log(this.state.vdrRischi)


let i;

for(i=0;i<this.state.vdrRischi.length;i++){
  unsplash
  .put('vdrRischi',{auth :"a5d42c3ed7977afa2d8e922569e7940b",rischio:this.state.vdrRischi[i]},
  { headers: {
    'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
  }}  );
}



break;  

    
      
}

  e.preventDefault();


 document.getElementById("toastButton").click();
 }
 
 
  constructor (props)
  {
      super(props);

      this.state = {
        idChecklist: "",
        visMod : false,
        arrayIndex:10,
        adlStruttura: [],
        mansioni:[],
        adlEmergenza: [],
        adlLuoghiLavoro: [],
        adlAttrezzature: [],
        formzFormazione:[],
        formzAddestramento:[],
        dtAmbienti:[],
        dtAttrezzature:[],
        dtImpianti:[],
        vdrDocValutazione:[],
        vdrRischi:[],
        dpi:[],
        opzioni: ["Si", "No"],
        opzioniApplicabili: ["Presenti", "Assenti", "Da approfondire"],
        opzioniPrimoSoccorso : ["Completata", "Da Completare", "Da Verificare","Periodica: Da Controllare","Non Applicabile"],
        cliente:"",
        livelloRischio:["Basso", "Medio", "Alto","Non Presente"],
        opzionImpianti:["Presente", "Assente"],
        opzioniCassetta:["Cassetta primo soccorso","pacchetto medicazione"],
        daDatiAziendali:[],
    };

  }
async componentDidMount(props){ 
  


   /* const response =  unsplash
    .get('adlStrutture',{auth :"a5d42c3ed7977afa2d8e922569e7940b",password:this.props.location.state.idChecklist} );*/
    this.setState({ idChecklist: this.props.location.state.idChecklist });
    //this.setState({ cliente: this.props.location.state.cliente });
    await unsplash.post('clientDetail',{auth : "a5d42c3ed7977afa2d8e922569e7940b",id:this.props.location.state.cliente.ID},
    { headers: {
      'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
    }}  )
        .then(res => {
            console.log(res);
            const clienteNew = res.data.data[0];
            
            console.log(clienteNew);
           
            this.setState({ cliente:clienteNew });
      
            console.log(this.state.clienteNew);
          })
          
            console.log(localStorage.getItem("jwt"));
            const responseLuoghiLavoro = await unsplash
              .get('adlLuoghiLavoro',{ headers: {
                'Authorization': `Bearer ${localStorage.getItem("jwt")}` 
              },params:{id:this.state.idChecklist}}
               );
           
              this.setState({ adlLuoghiLavoro: responseLuoghiLavoro.data.data });

            var i;
            var mansioniAttuali = [];
            for(i=0;i<this.state.adlLuoghiLavoro.length;i++){
              mansioniAttuali.push(this.state.adlLuoghiLavoro[i].Mansione)
            }
            this.setState({mansioni : mansioniAttuali});
            console.log(this.state.mansioni)
          
          



//console.log(this.props.location.state.idChecklist);

};









   
render(){
return(<div>

  <Toast></Toast>
  <CAccordion >
    <CAccordionItem itemKey={1}>
      <CAccordionHeader onClick={() => this.loadData("DatiAziendali")}> 
      DATI AZIENDALI
      </CAccordionHeader>
      <CAccordionBody>
      <IconButton aria-label="print" onClick={() => window.print()}>
<i class="bi bi-printer" style={{cursor:"pointer",width:"32px",height:"32px"}} ></i>
      </IconButton>


 <CRow className="align-items-start">
    <CCol md={6}>
    <CFormLabel htmlFor="RagioneSociale">Ragione Sociale</CFormLabel>
    <CFormInput type="text" id="RagioneSociale" name="RagioneSociale" value={typeof this.state.cliente.RagioneSociale != "undefined"? (this.state.cliente.RagioneSociale):""} onChange={(e) => this.handleChangeData(1,e,"Cliente")}/>
    </CCol>
    <CCol md={6}>
    <CFormLabel htmlFor="NomeAzienda">Nome dell'azienda</CFormLabel>
    <CFormInput type="text" id="NomeAzienda" value={this.state.cliente.RagioneSociale} name="NomeAzienda" placeholder="" onChange={this.handleChange}/>
    </CCol>
    </CRow>
    <CRow className="align-items-start">
    <CCol md={6}>
    <CFormLabel htmlFor="Rspp">RSPP</CFormLabel>
    <CFormInput type="text" id="Rspp" name="Rspp" placeholder=""/>
    </CCol>
    <CCol md={6}>
    <CFormLabel htmlFor="ConsulenteAssociato">Tecnico</CFormLabel>
    <CFormInput type="text" id="ConsulenteAssociato" value={typeof this.state.cliente.ConsulenteAssociato != "undefined"? (this.state.cliente.ConsulenteAssociato):""} onChange={(e) => this.handleChangeData(1,e,"Cliente")} name="ConsulenteAssociato" placeholder=""/>
    </CCol>
    </CRow>
    <CRow className="align-items-start">
    <CCol md={6}>
    <CFormLabel htmlFor="SedeIndirizzo">Sede Legale</CFormLabel>
    <CFormInput type="text" id="SedeLegale" value={typeof this.state.cliente.SedeIndirizzo != "undefined"? (this.state.cliente.SedeIndirizzo):""} onChange={(e) => this.handleChangeData(1,e,"Cliente")} name="SedeIndirizzo"/>
    </CCol>
    <CCol md={6}>
    <CFormLabel htmlFor="SedeCAP">CAP</CFormLabel>
    <CFormInput type="text" id="SedeCAP" value={typeof this.state.cliente.SedeCAP != "undefined"? (this.state.cliente.SedeCAP):""} onChange={(e) => this.handleChangeData(1,e,"Cliente")} name="SedeCAP"  placeholder=""/>
    </CCol>
    </CRow>
    <CRow className="align-items-start">
    <CCol md={6}>
    <CFormLabel htmlFor="SedeOperativa">Sede Operativa</CFormLabel>
    <CFormInput type="text" id="SedeOperativa" value={typeof this.state.cliente.RagioneSociale != "undefined"? (this.state.cliente.RagioneSociale.includes("-")? this.state.cliente.RagioneSociale.split("-")[1] :this.state.cliente.SedeIndirizzo ):""} onChange={(e) => this.handleChangeData(1,e,"Cliente")} name="SedeOperativa" placeholder=""/>
    </CCol>
    <CCol md={6}>
    <CFormLabel htmlFor="PIVA">P.IVA / CF</CFormLabel>
    <CFormInput type="text" id="PIVA" value={typeof this.state.cliente.PIVA != "undefined"?   this.state.cliente.PIVA:""} onChange={(e) => this.handleChangeData(1,e,"Cliente")} name="PIVA" placeholder=""/>
    </CCol>
    </CRow>
    <CRow className="align-items-start">
    <CCol md={6}>
    <CFormLabel htmlFor="DescrizioneSinteticaAttivita">Descrizione Sintetica Attività Principale</CFormLabel>
    <CFormTextarea style={{height:"38px"}} type="text" id="DescrizioneSinteticaAttivita" value={typeof this.state.cliente.DescrizioneSinteticaAttivita != "undefined"? (this.state.cliente.DescrizioneSinteticaAttivita):""} onChange={(e) => this.handleChangeData(1,e,"Cliente")} name="DescrizioneSinteticaAttivita"  />
    </CCol>
    <CCol md={6}>
    <CFormLabel htmlFor="Orario">Orario di lavoro</CFormLabel>
    <CFormInput type="text" id="OrarioDiLavoro" name="OrarioDiLavoro" value={typeof this.state.cliente.OrarioDiLavoro != "undefined"? (this.state.cliente.OrarioDiLavoro):""} onChange={(e) => this.handleChangeData(1,e,"Cliente")} placeholder=""/>
    </CCol>
    </CRow>
    <CRow className="align-items-start">
    <CCol md={6}>
    <CTable style={{marginTop:"30px"}}>
    <CTableBody>
    <CTableRow>
      <CTableHeaderCell scope="row">Sopralluoghi da contratto</CTableHeaderCell>
      <CTableDataCell><CFormInput type="text" id="UsciteAttive" name="UsciteAttive" value={typeof this.state.cliente.UsciteAttive != "undefined"? (this.state.cliente.UsciteAttive):""}></CFormInput></CTableDataCell>
      
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Data Sopralluogo</CTableHeaderCell>
      <CTableDataCell><CFormInput type="text" id="DataSopralluogo" name="DataSopralluogo" value={typeof this.state.cliente.DataSopralluogo != "undefined"? (this.state.cliente.DataSopralluogo):""} onChange={(e) => this.handleChangeData(1,e,"Cliente")}></CFormInput></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Numero Sopralluogo</CTableHeaderCell>
      <CTableDataCell><CFormInput type="text" id="NumeroSopralluogo" name="NumeroSopralluogo" value={typeof this.state.cliente.NumeroSopralluogo != "undefined"? (this.state.cliente.NumeroSopralluogo):""} onChange={(e) => this.handleChangeData(1,e,"Cliente")}></CFormInput></CTableDataCell>
    </CTableRow>
    </CTableBody>
    </CTable>
      </CCol>
      <CCol md={6}>
    <CTable style={{marginTop:"30px"}}>
    <CTableBody>
    <CTableRow>
      <CTableHeaderCell scope="row">Nome</CTableHeaderCell>
      <CTableDataCell> <CFormInput type="text" id="Referente" name="Referente" value={typeof this.state.cliente.Referente != "undefined"? (this.state.cliente.Referente):""} onChange={(e) => this.handleChangeData(1,e,"Cliente")}></CFormInput></CTableDataCell>
      
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Numero</CTableHeaderCell>
      <CTableDataCell> <CFormInput type="text" id="TelefonoReferente" name="TelefonoReferente" value={typeof this.state.cliente.TelefonoReferente != "undefined"? (this.state.cliente.TelefonoReferente):""} onChange={(e) => this.handleChangeData(1,e,"Cliente")}></CFormInput></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Mail</CTableHeaderCell>
      <CTableDataCell><CFormInput type="text" id="EmailReferente" name="EmailReferente" value={typeof this.state.cliente.EmailReferente != "undefined"? (this.state.cliente.EmailReferente):""} onChange={(e) => this.handleChangeData(1,e,"Cliente")}></CFormInput></CTableDataCell>
    </CTableRow>
    </CTableBody>
    </CTable>
      </CCol>
      </CRow>
      <center><CButton onClick={(e) => this.updateData(e,"Cliente")}>Salva</CButton></center>
    {/*TABELLA RIGA UNICA*/ }
    <h3>Dati aziendali</h3> 
    <CRow className="align-items-start">
    <CTable bordered style={{marginTop:"30px"}} responsive>
    <CTableHead>
    <CTableRow>
      <CTableHeaderCell scope="col"></CTableHeaderCell>
      <CTableHeaderCell scope="col">compilazione</CTableHeaderCell>
      <CTableHeaderCell scope="col">note</CTableHeaderCell>

    </CTableRow>
  </CTableHead>

    <CTableBody>
    <CTableRow>
      <CTableHeaderCell scope="row">Superficie</CTableHeaderCell>
      <CTableDataCell><CFormInput type="text" id="Superficie" name="Superficie"  value={typeof this.state.daDatiAziendali[0] != "undefined"? (this.state.daDatiAziendali[0].Superficie):""} onChange={(e) => this.handleChangeData(0,e,"DatiAziendali")}/></CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Superficie" name="Superficie"  value={typeof this.state.daDatiAziendali[1] != "undefined"? (this.state.daDatiAziendali[1].Superficie):""} onChange={(e) => this.handleChangeData(1,e,"DatiAziendali")}/></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Codice INPS</CTableHeaderCell>
      <CTableDataCell><CFormInput type="text" id="Codice_INPS" name="Codice_INPS"  value={typeof this.state.daDatiAziendali[0] != "undefined"? (this.state.daDatiAziendali[0].Codice_INPS):""} onChange={(e) => this.handleChangeData(0,e,"DatiAziendali")}/></CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Codice_INPS" name="Codice_INPS"  value={typeof this.state.daDatiAziendali[1] != "undefined"? (this.state.daDatiAziendali[1].Codice_INPS):""} onChange={(e) => this.handleChangeData(1,e,"DatiAziendali")}/></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Codice INAIL</CTableHeaderCell>
      <CTableDataCell><CFormInput type="text" id="Codice_INPS" name="Codice_INAIL"  value={typeof this.state.daDatiAziendali[0] != "undefined"? (this.state.daDatiAziendali[0].Codice_INAIL):""} onChange={(e) => this.handleChangeData(0,e,"DatiAziendali")}/></CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Codice_INPS" name="Codice_INAIL"  value={typeof this.state.daDatiAziendali[1] != "undefined"? (this.state.daDatiAziendali[1].Codice_INAIL):""} onChange={(e) => this.handleChangeData(1,e,"DatiAziendali")}/></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Classificazione Primo soccorso</CTableHeaderCell>
      <CTableDataCell><Dropdown options={["A","B/C"]} onChange={(e) => this.handleChangeData(0,e,"DatiAziendali","Classificazione_Primo_Soccorso")} value={typeof this.state.daDatiAziendali[0] != "undefined"? (this.state.daDatiAziendali[0].Classificazione_Primo_Soccorso):""} placeholder="Seleziona..." /></CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Classificazione_Primo_Soccorso" name="Classificazione_Primo_Soccorso"  value={typeof this.state.daDatiAziendali[1] != "undefined"? (this.state.daDatiAziendali[1].Classificazione_Primo_Soccorso):""} onChange={(e) => this.handleChangeData(1,e,"DatiAziendali")}/></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Presenza presidio di Primo soccorso</CTableHeaderCell>
      <CTableDataCell><Dropdown options={this.state.opzioniCassetta} onChange={(e) => this.handleChangeData(0,e,"DatiAziendali","Presenza_Cassetta")} value={typeof this.state.daDatiAziendali[0] != "undefined"? (this.state.daDatiAziendali[0].Presenza_Cassetta):""} placeholder="Seleziona..." /></CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Presenza_Cassetta" name="Presenza_Cassetta"  value={typeof this.state.daDatiAziendali[1] != "undefined"? (this.state.daDatiAziendali[1].Presenza_Cassetta):""} onChange={(e) => this.handleChangeData(1,e,"DatiAziendali")} placeholder="presente/assente"/></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Prova di evacuazione</CTableHeaderCell>
      <CTableDataCell><Dropdown options={this.state.opzioniPrimoSoccorso} onChange={(e) => this.handleChangeData(0,e,"DatiAziendali","Prova_Di_Evacuazione")} value={typeof this.state.daDatiAziendali[0] != "undefined"? (this.state.daDatiAziendali[0].Prova_Di_Evacuazione):""} placeholder="Seleziona..." /></CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Prova_Di_Evacuazione" name="Prova_Di_Evacuazione"  value={typeof this.state.daDatiAziendali[1] != "undefined"? (this.state.daDatiAziendali[1].Prova_Di_Evacuazione):""} onChange={(e) => this.handleChangeData(1,e,"DatiAziendali")}/></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Numero tot. Addetti</CTableHeaderCell>
      <CTableDataCell>
   
        <CFormInput  type="text" id="Numero_Tot_Addetti" name="Numero_Tot_Addetti"  value={typeof this.state.daDatiAziendali[0] != "undefined"? (this.state.daDatiAziendali[0].Numero_Tot_Addetti):""} onChange={(e) => this.handleChangeData(0,e,"DatiAziendali")}/>
       </CTableDataCell>
      
      <CTableDataCell><CFormInput type="text" id="Numero_Tot_Addetti" name="Numero_Tot_Addetti"  value={typeof this.state.daDatiAziendali[1] != "undefined"? (this.state.daDatiAziendali[1].Numero_Tot_Addetti):""} onChange={(e) => this.handleChangeData(1,e,"DatiAziendali")}/></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Femmine</CTableHeaderCell>
      <CTableDataCell>
   
        <CFormInput  type="text" id="N_Femmine" name="N_Femmine"  value={typeof this.state.daDatiAziendali[0] != "undefined"? (this.state.daDatiAziendali[0].N_Femmine):""} onChange={(e) => this.handleChangeData(0,e,"DatiAziendali")}/>
       </CTableDataCell>
      
      <CTableDataCell><CFormInput type="text" id="N_Femmine" name="N_Femmine"  value={typeof this.state.daDatiAziendali[1] != "undefined"? (this.state.daDatiAziendali[1].N_Femmine):""} onChange={(e) => this.handleChangeData(1,e,"DatiAziendali")}/></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Maschi</CTableHeaderCell>
      <CTableDataCell>
   
        <CFormInput  type="text" id="N_Maschi" name="N_Maschi"  value={typeof this.state.daDatiAziendali[0] != "undefined"? (this.state.daDatiAziendali[0].N_Maschi):""} onChange={(e) => this.handleChangeData(0,e,"DatiAziendali")}/>
       </CTableDataCell>
      
      <CTableDataCell><CFormInput type="text" id="N_Maschi" name="N_Maschi"  value={typeof this.state.daDatiAziendali[1] != "undefined"? (this.state.daDatiAziendali[1].N_Maschi):""} onChange={(e) => this.handleChangeData(1,e,"DatiAziendali")}/></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Lavoratori notturni</CTableHeaderCell>
      <CTableDataCell><Dropdown options={this.state.opzioni} onChange={(e) => this.handleChangeData(0,e,"DatiAziendali","Lavoratori_Notturni")} value={typeof this.state.daDatiAziendali[0] != "undefined"? (this.state.daDatiAziendali[0].Lavoratori_Notturni):""} placeholder="Seleziona..." /></CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Lavoratori_Notturni" name="Lavoratori_Notturni"  value={typeof this.state.daDatiAziendali[1] != "undefined"? (this.state.daDatiAziendali[1].Lavoratori_Notturni):""} onChange={(e) => this.handleChangeData(1,e,"DatiAziendali")}/></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Lavoratori minori</CTableHeaderCell>
      <CTableDataCell><Dropdown options={this.state.opzioni} onChange={(e) => this.handleChangeData(0,e,"DatiAziendali","Lavoratori_Minori")} value={typeof this.state.daDatiAziendali[0] != "undefined"? (this.state.daDatiAziendali[0].Lavoratori_Minori):""} placeholder="Seleziona..." /></CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Lavoratori_Minori" name="Lavoratori_Minori"  value={typeof this.state.daDatiAziendali[1] != "undefined"? (this.state.daDatiAziendali[1].Lavoratori_Minori):""} onChange={(e) => this.handleChangeData(1,e,"DatiAziendali")}/></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Lavoratori stranieri</CTableHeaderCell>
      <CTableDataCell><Dropdown options={this.state.opzioni} onChange={(e) => this.handleChangeData(0,e,"DatiAziendali","Lavoratori_Stranieri")} value={typeof this.state.daDatiAziendali[0] != "undefined"? (this.state.daDatiAziendali[0].Lavoratori_Stranieri):""} placeholder="Seleziona..." /></CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Lavoratori_Stranieri" name="Lavoratori_Stranieri"  value={typeof this.state.daDatiAziendali[1] != "undefined"? (this.state.daDatiAziendali[1].Lavoratori_Stranieri):""} onChange={(e) => this.handleChangeData(1,e,"DatiAziendali")}/></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Smart working</CTableHeaderCell>
      <CTableDataCell><Dropdown options={this.state.opzioni} onChange={(e) => this.handleChangeData(0,e,"DatiAziendali","Smartworking")} value={typeof this.state.daDatiAziendali[0] != "undefined"? (this.state.daDatiAziendali[0].Smartworking):""} placeholder="Seleziona..." /></CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Smartworking" name="Smartworking"  value={typeof this.state.daDatiAziendali[1] != "undefined"? (this.state.daDatiAziendali[1].Smartworking):""} onChange={(e) => this.handleChangeData(1,e,"DatiAziendali")}/></CTableDataCell>
    </CTableRow>
    
 
    </CTableBody>
    </CTable>
      </CRow>

      <center><CButton onClick={(e) => this.updateData(e,"DatiAziendali")}>Salva</CButton></center>
      </CAccordionBody>
    </CAccordionItem>
    <CAccordionItem itemKey={2}>
      <CAccordionHeader onClick={() => this.loadData("AmbientiDiLavoro")}>
        AMBIENTI DI LAVORO
      </CAccordionHeader>
      <CAccordionBody> {/*CONTENUTO AMBIENTI DI LAVORO*/}
      <IconButton aria-label="print" onClick={() => window.print()}>
<i class="bi bi-printer" style={{cursor:"pointer",width:"32px",height:"32px"}} ></i>
      </IconButton>
      <h3>Luoghi di lavoro / Mansione</h3> 
      <CTable bordered>
  <CTableHead>
    <CTableRow>
    
      <CTableHeaderCell scope="col">Reparto</CTableHeaderCell>
      <CTableHeaderCell scope="col">Mansione</CTableHeaderCell>
      <CTableHeaderCell scope="col">Descrizione</CTableHeaderCell>
      <CTableHeaderCell scope="col">Compatibile gravidanza</CTableHeaderCell>
      <CTableHeaderCell scope="col">Note</CTableHeaderCell>
      <CTableHeaderCell scope="col"></CTableHeaderCell>
    </CTableRow>
  </CTableHead>
  <CTableBody>
{
   this.state.adlLuoghiLavoro.map((luogo) =>
   <CTableRow key={luogo.ID}>
   <CTableDataCell>
   <p >{luogo.Reparto}</p>
   </CTableDataCell>
   <CTableDataCell>
   <p >{luogo.Mansione}</p>
   </CTableDataCell>
   <CTableDataCell>
   <CFormTextarea style={{height:"38px"}} value ={luogo.Descrizione} readOnly={true}></CFormTextarea>
   </CTableDataCell>
   <CTableDataCell>
   <p >{luogo.Compatile_Gravidanza}</p>
   </CTableDataCell>
   <CTableDataCell>
   <CFormTextarea style={{height:"38px"}} value ={luogo.Note} readOnly={true}/>
   </CTableDataCell>
   <CTableDataCell>
   <CButton style={{marginRight:"15px"}} color="danger" onClick={() => this.deleteData(luogo.ID,luogo.Mansione,"luogoDiLavoro")}> Rimuovi</CButton>
   <Modal myFunction={this.editFromModal}
title="Modifica"
tipologia="LuoghiDiLavoro"
data={{items: [
  {  id: 1, text: "Reparto",val:luogo.Reparto},
  {  id: 2,  text: "Mansione",val:luogo.Mansione},
  {  id: 3,  text: "Descrizione",val:luogo.Descrizione},
  {  id: 4, text: "Compatile Gravidanza",val:luogo.Compatile_Gravidanza},
  {  id: 5, text: 'Note',val:luogo.Note},
  {  id: 6, text: 'ID',val:luogo.ID}
  ],dpi:[],currentDpi:[]}}


/>
   </CTableDataCell>

   </CTableRow>
   )
 } 
</CTableBody>
</CTable>


<Modal myFunction={this.inputFromModal}
title="Aggiungi luogo di lavoro"
tipologia="LuoghiDiLavoro"
data={{items: [
  {  id: 1, text: "Reparto",val:""},
  {  id: 2,  text: "Mansione",val:""},
  {  id: 3,  text: "Descrizione",val:""},
  {  id: 4, text: "Compatile Gravidanza",val:""},
  {  id: 5, text: 'Note',val:""}
  ]}}


/>
    

<h3>Attrezzature / Macchine</h3> 
      <CTable bordered>
  <CTableHead>
    <CTableRow>
    
      <CTableHeaderCell scope="col">Macchina / Attrezzatura</CTableHeaderCell>
      <CTableHeaderCell scope="col">Ubicazione</CTableHeaderCell>
      <CTableHeaderCell scope="col">Mansione</CTableHeaderCell>
      <CTableHeaderCell scope="col">Libretto Uso/Manutenzione</CTableHeaderCell>
      <CTableHeaderCell scope="col">Macatura CE</CTableHeaderCell>
      <CTableHeaderCell scope="col">Note</CTableHeaderCell>
      <CTableHeaderCell scope="col"></CTableHeaderCell>
    </CTableRow>
  </CTableHead>
  <CTableBody>
{
   this.state.adlAttrezzature.map((attrezzatura) =>
   <CTableRow key={attrezzatura.ID}>
   <CTableDataCell>
   <p >{attrezzatura.Attrezzatura}</p>
   </CTableDataCell>
   <CTableDataCell>
   <p >{attrezzatura.Ubicazione}</p>
   </CTableDataCell>
   <CTableDataCell>
   <p >{attrezzatura.Mansione}</p>
   </CTableDataCell>
   <CTableDataCell>
   <p >{attrezzatura.Libretto}</p>
   </CTableDataCell>
   <CTableDataCell>
   <p >{attrezzatura.Marcatura_CE}</p>
   </CTableDataCell>
   <CTableDataCell>
   <CFormTextarea style={{height:"38px"}} value ={attrezzatura.Note} readOnly={true}/>
   </CTableDataCell>
   <CTableDataCell>
   <CButton color="danger" style={{marginRight:"15px"}} onClick={() => this.deleteData(attrezzatura.ID,attrezzatura.Mansione,"Attrezzature")}> Rimuovi</CButton>
   <Modal myFunction={this.editFromModal}
title="Modifica"
tipologia="Attrezzature"
data={{items: [
  {  id: 1, text: "Macchina / Attrezzatura",val:attrezzatura.Attrezzatura},
  {  id: 2,  text: "Ubicazione",val:attrezzatura.Ubicazione},
  {  id: 3,  text: "Mansione",val:attrezzatura.Mansione},
  {  id: 4, text: "Libretto Uso/Manutenzione",val:attrezzatura.Libretto},
  {  id: 5, text: "Marcatura CE",val:attrezzatura.Marcatura_CE},
  {  id: 6, text: 'Note',val:attrezzatura.Note},
  {  id: 7, text: 'ID',val:attrezzatura.ID}
  ],dpi:[],currentDpi:[],mansioni:(this.state.adlLuoghiLavoro.map(mansione => mansione.Mansione)),luoghi:this.state.adlLuoghiLavoro.map(luogo => luogo.Reparto)}}


/>
   </CTableDataCell>

   </CTableRow>
   )
 } 
</CTableBody>
</CTable>


<Modal myFunction={this.inputFromModal}
title="Aggiungi Attrezzatura"
tipologia="Attrezzature"
data={{items: [
  {  id: 1, text: "Macchina / Attrezzatura",val:""},
  {  id: 2,  text: "Ubicazione",val:""},
  {  id: 3,  text: "Mansione",val:""},
  {  id: 4, text: "Libretto Uso/Manutenzione",val:""},
  {  id: 5, text: "Marcatura CE",val:""},
  {  id: 6, text: 'Note',val:""}
  ],dpi:[],currentDpi:[],mansioni:(this.state.adlLuoghiLavoro.map(mansione =>mansione.Mansione)),luoghi:(this.state.adlLuoghiLavoro.map(luogo =>luogo.Reparto))}}


/>







<h3>Strutture</h3> 
{/*Struttura*/}
<CForm>
      <CTable bordered>
  <CTableHead>
    <CTableRow>
    
      <CTableHeaderCell scope="col">Descrizione</CTableHeaderCell>
      <CTableHeaderCell scope="col">Applicabilità</CTableHeaderCell>
      <CTableHeaderCell scope="col">Note</CTableHeaderCell>
    </CTableRow>
  </CTableHead>
  <CTableBody>
    <CTableRow>
      <CTableHeaderCell scope="row">Locale ricarica carrelli elevatori</CTableHeaderCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzioniApplicabili} onChange={(e) => this.handleChangeData(0,e,"Struttura","Carrelli_Elevatori")} value={typeof this.state.adlStruttura[0] != "undefined"? (this.state.adlStruttura[0].Carrelli_Elevatori):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Carrelli_Elevatori" name="Carrelli_Elevatori" ref={(carrelliElevatoriNote) => (this.carrelliElevatoriNote = carrelliElevatoriNote)} value={typeof this.state.adlStruttura[1] != "undefined"? (this.state.adlStruttura[1].Carrelli_Elevatori):""} onChange={(e) => this.handleChangeData(1,e,"Struttura")}/></CTableDataCell>
  
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Spogliatoi</CTableHeaderCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzioniApplicabili} onChange={(e) => this.handleChangeData(0,e,"Struttura","Spogliatoi")} value={typeof this.state.adlStruttura[0] != "undefined"? (this.state.adlStruttura[0].Spogliatoi):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell><CFormInput ref={(spogliatoiNote) => (this.spogliatoiNote = spogliatoiNote)} type="text" id="Spogliatoi" name="Spogliatoi" value={typeof this.state.adlStruttura[1] != "undefined"? (this.state.adlStruttura[1].Spogliatoi):""} onChange={(e) => this.handleChangeData(1,e,"Struttura")}/></CTableDataCell>

    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Mensa / area break</CTableHeaderCell>
      <CTableDataCell >
      <Dropdown options={this.state.opzioniApplicabili} onChange={(e) => this.handleChangeData(0,e,"Struttura","Mensa")} value={typeof this.state.adlStruttura[0] != "undefined"? (this.state.adlStruttura[0].Mensa):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell><CFormInput type="text"  id="Mensa" name="Mensa" ref={(serviziIgieniciNote) => (this.serviziIgieniciNote = serviziIgieniciNote)} value={typeof this.state.adlStruttura[1] != "undefined"? (this.state.adlStruttura[1].Mensa):""} onChange={(e) => this.handleChangeData(1,e,"Struttura")}/></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Ascensori e montacarichi</CTableHeaderCell>
      <CTableDataCell >
      <Dropdown options={this.state.opzioniApplicabili} onChange={(e) => this.handleChangeData(0,e,"Struttura","Ascensori")} value={typeof this.state.adlStruttura[0] != "undefined"? (this.state.adlStruttura[0].Ascensori):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell><CFormInput ref={(mensaNote) => (this.mensaNote = mensaNote)} type="text" id="Ascensori" name="Ascensori" value={typeof this.state.adlStruttura[1] != "undefined"? (this.state.adlStruttura[1].Ascensori):""} onChange={(e) => this.handleChangeData(1,e,"Struttura")}/></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Scaffalature</CTableHeaderCell>
      <CTableDataCell > <Dropdown options={this.state.opzioniApplicabili} onChange={(e) => this.handleChangeData(0,e,"Struttura","Scaffalature")} value={typeof this.state.adlStruttura[0] != "undefined"? (this.state.adlStruttura[0].Scaffalature):""} placeholder="Seleziona..." /></CTableDataCell>
      <CTableDataCell><CFormInput ref={(ascensoriNote) => (this.ascensoriNote = ascensoriNote)} type="text" id="Scaffalature" name="Scaffalature"  value={typeof this.state.adlStruttura[1] != "undefined"? (this.state.adlStruttura[1].Scaffalature):""} onChange={(e) => this.handleChangeData(1,e,"Struttura")}/></CTableDataCell>
    </CTableRow>
  </CTableBody>
</CTable>
<center><CButton onClick={(e) => this.updateData(e,"Struttura")}>Salva</CButton></center>
</CForm>

{/* Emergenza */}
<h3>Emergenza / Incendio</h3> 
<CForm>
      <CTable bordered>
  <CTableHead>
    <CTableRow>
    
      <CTableHeaderCell scope="col">Descrizione</CTableHeaderCell>
      <CTableHeaderCell scope="col">Applicabilità</CTableHeaderCell>
      <CTableHeaderCell scope="col">Note</CTableHeaderCell>
    </CTableRow>
  </CTableHead>
  <CTableBody>
  <CTableRow>
      <CTableHeaderCell scope="row">Prova di evacuazione</CTableHeaderCell>
      <CTableDataCell>
      <Dropdown options={["Soggetto","Non Soggetto"]} onChange={(e) => this.handleChangeData(0,e,"Emergenza","Prova_di_Evacuazione")} value={typeof this.state.adlEmergenza[0] != "undefined"? (this.state.adlEmergenza[0].Estintori):""} placeholder="Seleziona..." />

      </CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Prova_di_Evacuazione" name="Prova_di_Evacuazione" value={typeof this.state.adlEmergenza[1] != "undefined"? (this.state.adlEmergenza[1].Prova_di_Evacuazione):""} onChange={(e) => this.handleChangeData(1,e,"Emergenza")}/></CTableDataCell>
  
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Estintori</CTableHeaderCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzioniApplicabili} onChange={(e) => this.handleChangeData(0,e,"Emergenza","Estintori")} value={typeof this.state.adlEmergenza[0] != "undefined"? (this.state.adlEmergenza[0].Estintori):""} placeholder="Seleziona..." />

      </CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Estintori" name="Estintori" value={typeof this.state.adlEmergenza[1] != "undefined"? (this.state.adlEmergenza[1].Estintori):""} onChange={(e) => this.handleChangeData(1,e,"Emergenza")}/></CTableDataCell>
  
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Idranti</CTableHeaderCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzioniApplicabili} onChange={(e) => this.handleChangeData(0,e,"Emergenza","Idranti")} value={typeof this.state.adlEmergenza[0] != "undefined"? (this.state.adlEmergenza[0].Idranti):""} placeholder="Seleziona..." />

      </CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Idranti" name="Idranti" value={typeof this.state.adlEmergenza[1] != "undefined"? (this.state.adlEmergenza[1].Idranti):""} onChange={(e) => this.handleChangeData(1,e,"Emergenza")}/></CTableDataCell>

    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Rilevatori fumo e calore</CTableHeaderCell>
      <CTableDataCell >
      <Dropdown options={this.state.opzioniApplicabili} onChange={(e) => this.handleChangeData(0,e,"Emergenza","Rilevatori_Fumo")} value={typeof this.state.adlEmergenza[0] != "undefined"? (this.state.adlEmergenza[0].Rilevatori_Fumo):""} placeholder="Seleziona..." />

      </CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Rilevatori_Fumo" name="Rilevatori_Fumo" value={typeof this.state.adlEmergenza[1] != "undefined"? (this.state.adlEmergenza[1].Rilevatori_Fumo):""} onChange={(e) => this.handleChangeData(1,e,"Emergenza")}/></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Illuminazione di emergenza</CTableHeaderCell>
      <CTableDataCell >
      <Dropdown options={this.state.opzioniApplicabili} onChange={(e) => this.handleChangeData(0,e,"Emergenza","Illuminazione_Emergenza")} value={typeof this.state.adlEmergenza[0] != "undefined"? (this.state.adlEmergenza[0].Illuminazione_Emergenza):""} placeholder="Seleziona..." />

      </CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Illuminazione_Emergenza" name="Illuminazione_Emergenza" value={typeof this.state.adlEmergenza[1] != "undefined"? (this.state.adlEmergenza[1].Illuminazione_Emergenza):""} onChange={(e) => this.handleChangeData(1,e,"Emergenza")}/></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Allarme antincendio</CTableHeaderCell>
      <CTableDataCell >
      <Dropdown options={this.state.opzioniApplicabili} onChange={(e) => this.handleChangeData(0,e,"Emergenza","Allarme_Antincendio")} value={typeof this.state.adlEmergenza[0] != "undefined"? (this.state.adlEmergenza[0].Allarme_Antincendio):""} placeholder="Seleziona..." />


      </CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Allarme_Antincendio" name="Allarme_Antincendio" value={typeof this.state.adlEmergenza[1] != "undefined"? (this.state.adlEmergenza[1].Allarme_Antincendio):""} onChange={(e) => this.handleChangeData(1,e,"Emergenza")}/></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Registro attrezzature antincendio</CTableHeaderCell>
      <CTableDataCell ><Dropdown options={this.state.opzioniApplicabili} onChange={(e) => this.handleChangeData(0,e,"Emergenza","Registro_Attrezzature")} value={typeof this.state.adlEmergenza[0] != "undefined"? (this.state.adlEmergenza[0].Registro_Attrezzature):""} placeholder="Seleziona..." />
</CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Registro_Attrezzature" name="Registro_Attrezzature" value={typeof this.state.adlEmergenza[1] != "undefined"? (this.state.adlEmergenza[1].Registro_Attrezzature):""} onChange={(e) => this.handleChangeData(1,e,"Emergenza")}/></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Uscite di emergenza</CTableHeaderCell>
      <CTableDataCell ><Dropdown options={this.state.opzioniApplicabili} onChange={(e) => this.handleChangeData(0,e,"Emergenza","Uscite_Emergenza")} value={typeof this.state.adlEmergenza[0] != "undefined"? (this.state.adlEmergenza[0].Uscite_Emergenza):""} placeholder="Seleziona..." /></CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Uscite_Emergenza" name="Uscite_Emergenza" value={typeof this.state.adlEmergenza[1] != "undefined"? (this.state.adlEmergenza[1].Uscite_Emergenza):""} onChange={(e) => this.handleChangeData(1,e,"Emergenza")}/></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Planimetrie</CTableHeaderCell>
      <CTableDataCell ><Dropdown options={this.state.opzioniApplicabili} onChange={(e) => this.handleChangeData(0,e,"Emergenza","Planimetrie")} value={typeof this.state.adlEmergenza[0] != "undefined"? (this.state.adlEmergenza[0].Planimetrie):""} placeholder="Seleziona..." /></CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Planimetrie" name="Planimetrie" value={typeof this.state.adlEmergenza[1] != "undefined"? (this.state.adlEmergenza[1].Planimetrie):""} onChange={(e) => this.handleChangeData(1,e,"Emergenza")}/></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Attività soggetta a prevenzione incendi</CTableHeaderCell>
      <CTableDataCell ><Dropdown options={this.state.opzioniApplicabili} onChange={(e) => this.handleChangeData(0,e,"Emergenza","Attivita_Prevenzione_Incendi")} value={typeof this.state.adlEmergenza[0] != "undefined"? (this.state.adlEmergenza[0].Attivita_Prevenzione_Incendi):""} placeholder="Seleziona..." /></CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Attivita_Prevenzione_Incendi" name="Attivita_Prevenzione_Incendi" value={typeof this.state.adlEmergenza[1] != "undefined"? (this.state.adlEmergenza[1].Attivita_Prevenzione_Incendi):""} onChange={(e) => this.handleChangeData(1,e,"Emergenza")}/></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Rischio incendio DM 10/03/98</CTableHeaderCell>
      <CTableDataCell ><Dropdown options={["BASSO","MEDIO","ALTO"]} onChange={(e) => this.handleChangeData(0,e,"Emergenza","Rischio_Incendio")} value={typeof this.state.adlEmergenza[0] != "undefined"? (this.state.adlEmergenza[0].Rischio_Incendio):""} placeholder="Seleziona..." /></CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Rischio_Incendio" name="Rischio_Incendio" value={typeof this.state.adlEmergenza[1] != "undefined"? (this.state.adlEmergenza[1].Rischio_Incendio):""} onChange={(e) => this.handleChangeData(1,e,"Emergenza")}/></CTableDataCell>
    </CTableRow>
    {/*<CTableRow>
      <CTableHeaderCell>Presenza presidio di Primo soccorso</CTableHeaderCell>
      <CTableDataCell ><Dropdown options={this.state.opzioniCassetta} onChange={(e) => this.handleChangeData(0,e,"Emergenza","Cassetta_Primo_Soccorso")} value={typeof this.state.adlEmergenza[0] != "undefined"? (this.state.adlEmergenza[0].Cassetta_Primo_Soccorso):""} placeholder="Seleziona..." /></CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Cassetta_Primo_Soccorso" name="Cassetta_Primo_Soccorso" value={typeof this.state.adlEmergenza[1] != "undefined"? (this.state.adlEmergenza[1].Cassetta_Primo_Soccorso):""} onChange={(e) => this.handleChangeData(1,e,"Emergenza")}/></CTableDataCell>
    </CTableRow>*/}
    </CTableBody>
</CTable>
<center><CButton onClick={(e) => this.updateData(e,"Emergenza")}>Salva</CButton></center>
</CForm>
      </CAccordionBody>
    </CAccordionItem>


    {/*FORMAZIONE*/}
    <CAccordionItem itemKey={3} onClick={() => this.loadData("Formazione")}>
      <CAccordionHeader>
       FORMAZIONE
      </CAccordionHeader>
      <CAccordionBody>
      <IconButton aria-label="print" onClick={() => window.print()}>
<i class="bi bi-printer" style={{cursor:"pointer",width:"32px",height:"32px"}} ></i>
      </IconButton>
   {/*Formazione*/}
   <h3>Formazione specifica aggiuntiva</h3> 
<CForm>
      <CTable bordered>
  <CTableHead>
    <CTableRow>
    
      <CTableHeaderCell scope="col">Descrizione</CTableHeaderCell>
      <CTableHeaderCell scope="col">Applicabilità</CTableHeaderCell>
      <CTableHeaderCell scope="col">Note</CTableHeaderCell>
    </CTableRow>
  </CTableHead>
  <CTableBody>
    <CTableRow>
      <CTableHeaderCell scope="row">Formazione Carrellisti</CTableHeaderCell>
      <CTableDataCell > <Dropdown options={this.state.opzioni} onChange={(e) => this.handleChangeData(0,e,"Formazione","Form_Carrellisti")} value={typeof this.state.formzFormazione[0] != "undefined"? (this.state.formzFormazione[0].Form_Carrellisti):""} placeholder="Seleziona..." /></CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Form_Carrellisti" name="Form_Carrellisti"  value={typeof this.state.formzFormazione[1] != "undefined"? (this.state.formzFormazione[1].Form_Carrellisti):""} onChange={(e) => this.handleChangeData(1,e,"Formazione")}/></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Ambienti Confinati</CTableHeaderCell>
      <CTableDataCell > <Dropdown options={this.state.opzioni} onChange={(e) => this.handleChangeData(0,e,"Formazione","Ambienti_Confinati")} value={typeof this.state.formzFormazione[0] != "undefined"? (this.state.formzFormazione[0].Ambienti_Confinati):""} placeholder="Seleziona..." /></CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Ambienti_Confinati" name="Ambienti_Confinati"  value={typeof this.state.formzFormazione[1] != "undefined"? (this.state.formzFormazione[1].Ambienti_Confinati):""} onChange={(e) => this.handleChangeData(1,e,"Formazione")}/></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Pes Pav Pei</CTableHeaderCell>
      <CTableDataCell > <Dropdown options={this.state.opzioni} onChange={(e) => this.handleChangeData(0,e,"Formazione","Pes_Pav_Pei")} value={typeof this.state.formzFormazione[0] != "undefined"? (this.state.formzFormazione[0].Pes_Pav_Pei):""} placeholder="Seleziona..." /></CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Pes_Pav_Pei" name="Pes_Pav_Pei"  value={typeof this.state.formzFormazione[1] != "undefined"? (this.state.formzFormazione[1].Pes_Pav_Pei):""} onChange={(e) => this.handleChangeData(1,e,"Formazione")}/></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">DPI 3ª Categoria</CTableHeaderCell>
      <CTableDataCell > <Dropdown options={this.state.opzioni} onChange={(e) => this.handleChangeData(0,e,"Formazione","DPI")} value={typeof this.state.formzFormazione[0] != "undefined"? (this.state.formzFormazione[0].DPI):""} placeholder="Seleziona..." /></CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="DPI" name="DPI"  value={typeof this.state.formzFormazione[1] != "undefined"? (this.state.formzFormazione[1].DPI):""} onChange={(e) => this.handleChangeData(1,e,"Formazione")}/></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Carroponte</CTableHeaderCell>
      <CTableDataCell > <Dropdown options={this.state.opzioni} onChange={(e) => this.handleChangeData(0,e,"Formazione","Carroponte")} value={typeof this.state.formzFormazione[0] != "undefined"? (this.state.formzFormazione[0].Carroponte):""} placeholder="Seleziona..." /></CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Carroponte" name="Carroponte"  value={typeof this.state.formzFormazione[1] != "undefined"? (this.state.formzFormazione[1].Carroponte):""} onChange={(e) => this.handleChangeData(1,e,"Formazione")}/></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Lavoro In Quota</CTableHeaderCell>
      <CTableDataCell > <Dropdown options={this.state.opzioni} onChange={(e) => this.handleChangeData(0,e,"Formazione","Lavoro_In_Quota")} value={typeof this.state.formzFormazione[0] != "undefined"? (this.state.formzFormazione[0].Lavoro_In_Quota):""} placeholder="Seleziona..." /></CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Lavoro_In_Quota" name="Lavoro_In_Quota"  value={typeof this.state.formzFormazione[1] != "undefined"? (this.state.formzFormazione[1].Lavoro_In_Quota):""} onChange={(e) => this.handleChangeData(1,e,"Formazione")}/></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">PLE</CTableHeaderCell>
      <CTableDataCell > <Dropdown options={this.state.opzioni} onChange={(e) => this.handleChangeData(0,e,"Formazione","PLE")} value={typeof this.state.formzFormazione[0] != "undefined"? (this.state.formzFormazione[0].PLE):""} placeholder="Seleziona..." /></CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="PLE" name="PLE"  value={typeof this.state.formzFormazione[1] != "undefined"? (this.state.formzFormazione[1].PLE):""} onChange={(e) => this.handleChangeData(1,e,"Formazione")}/></CTableDataCell>
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Altro</CTableHeaderCell>
      <CTableDataCell > <Dropdown options={this.state.opzioni} onChange={(e) => this.handleChangeData(0,e,"Formazione","Altro")} value={typeof this.state.formzFormazione[0] != "undefined"? (this.state.formzFormazione[0].Altro):""} placeholder="Seleziona..." /></CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Altro" name="Altro"  value={typeof this.state.formzFormazione[1] != "undefined"? (this.state.formzFormazione[1].Altro):""} onChange={(e) => this.handleChangeData(1,e,"Formazione")}/></CTableDataCell>
    </CTableRow>
  </CTableBody>
</CTable>
<center><CButton onClick={(e) => this.updateData(e,"Formazione")}>Salva</CButton></center>
</CForm>
<h3>Addestramento</h3> 
<CTable bordered>
  <CTableHead>
    <CTableRow>
    
      <CTableHeaderCell scope="col">Mansione</CTableHeaderCell>
      <CTableHeaderCell scope="col">Necessario addestramento</CTableHeaderCell>
      <CTableHeaderCell scope="col">Note</CTableHeaderCell>
      <CTableHeaderCell scope="col">Data Verbale Addestramento</CTableHeaderCell>
      <CTableHeaderCell scope="col"></CTableHeaderCell>
    </CTableRow>
  </CTableHead>
  <CTableBody>
{
   this.state.formzAddestramento.map((addestramento) =>
   <CTableRow key={addestramento.ID}>
   <CTableDataCell>
   <p>{addestramento.Mansione}</p>
   </CTableDataCell>
   <CTableDataCell>
   <p>{addestramento.Addestramento}</p>
   </CTableDataCell>
   <CTableDataCell>
   <p>{addestramento.Note}</p>
   </CTableDataCell>
   <CTableDataCell>
   <p>{addestramento.Data_Addestramento}</p>
   </CTableDataCell>
   <CTableDataCell>
   <CButton color="danger" onClick={() => this.deleteData(addestramento.ID,"Addestramento")}> Rimuovi</CButton>
   </CTableDataCell>
   </CTableRow>
   )
 } 
</CTableBody>
</CTable>
<Modal myFunction={this.inputFromModal}
title="Aggiungi Addestramento"
tipologia="Addestramento"
data={{items: [
  {  id: 1, text: "Mansione",val:""},
  {  id: 2,  text: "Addestramento",val:""},
  {  id: 3,  text: "Note",val:""},
  {  id: 4,  text: "Data_addestramento",val:""}
  ]}}


/>




      </CAccordionBody>
    </CAccordionItem>
    <CAccordionItem itemKey={4} onClick={() => this.loadData("DocumentazioneTecnica")}>
      <CAccordionHeader>
       DOCUMENTAZIONE TECNICA
      </CAccordionHeader>
      <CAccordionBody>
      <IconButton aria-label="print" onClick={() => window.print()}>
<i class="bi bi-printer" style={{cursor:"pointer",width:"32px",height:"32px"}} ></i>
      </IconButton>
        {/* AMBIENTI */}
      <h3>Ambienti</h3> 
<CForm>
      <CTable bordered>
  <CTableHead>
    <CTableRow>
    
      <CTableHeaderCell scope="col">Descrizione</CTableHeaderCell>
      <CTableHeaderCell scope="col">Applicabilità</CTableHeaderCell>
      <CTableHeaderCell scope="col">Note</CTableHeaderCell>
    </CTableRow>
  </CTableHead>
  <CTableBody>
    <CTableRow>
      <CTableHeaderCell scope="row">Inizio Attività</CTableHeaderCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzioni} onChange={(e) => this.handleChangeData(0,e,"Ambienti","Inizio_Attivita")} value={typeof this.state.dtAmbienti[0] != "undefined"? (this.state.dtAmbienti[0].Inizio_Attivita):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Inizio_Attivita" name="Inizio_Attivita" value={typeof this.state.dtAmbienti[1] != "undefined"? (this.state.dtAmbienti[1].Inizio_Attivita):""} onChange={(e) => this.handleChangeData(1,e,"Ambienti")}/></CTableDataCell>
  
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Agibilità</CTableHeaderCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzioni} onChange={(e) => this.handleChangeData(0,e,"Ambienti","Agibilita")} value={typeof this.state.dtAmbienti[0] != "undefined"? (this.state.dtAmbienti[0].Agibilita):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Agibilita" name="Agibilita" value={typeof this.state.dtAmbienti[1] != "undefined"? (this.state.dtAmbienti[1].Agibilita):""} onChange={(e) => this.handleChangeData(1,e,"Ambienti")}/></CTableDataCell>
  
    </CTableRow>
    
  </CTableBody>
</CTable>
<center><CButton onClick={(e) => this.updateData(e,"Ambienti")}>Salva</CButton></center>
</CForm>
{/* ATTREZZATURE 
<h3>Attrezzature</h3> 
<CForm>
      <CTable bordered>
  <CTableHead>
    <CTableRow>
    
      <CTableHeaderCell scope="col">Descrizione</CTableHeaderCell>
      <CTableHeaderCell scope="col">Applicabilità</CTableHeaderCell>
      <CTableHeaderCell scope="col">Note</CTableHeaderCell>
    </CTableRow>
  </CTableHead>
  <CTableBody>
    <CTableRow>
      <CTableHeaderCell scope="row">Verifica DPI</CTableHeaderCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzioni} onChange={(e) => this.handleChangeData(0,e,"Attrezzature","Verifica_DPI")} value={typeof this.state.dtAttrezzature[0] != "undefined"? (this.state.dtAttrezzature[0].Verifica_DPI):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Verifica_DPI" name="Verifica_DPI" value={typeof this.state.dtAttrezzature[1] != "undefined"? (this.state.dtAttrezzature[1].Verifica_DPI):""} onChange={(e) => this.handleChangeData(1,e,"Attrezzature")}/></CTableDataCell>
  
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Carrelli Elevatori</CTableHeaderCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzioni} onChange={(e) => this.handleChangeData(0,e,"Attrezzature","Carrelli_Elevatori")} value={typeof this.state.dtAttrezzature[0] != "undefined"? (this.state.dtAttrezzature[0].Carrelli_Elevatori):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Carrelli_Elevatori" name="Carrelli_Elevatori" value={typeof this.state.dtAttrezzature[1] != "undefined"? (this.state.dtAttrezzature[1].Carrelli_Elevatori):""} onChange={(e) => this.handleChangeData(1,e,"Attrezzature")}/></CTableDataCell>
  
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Carroponte</CTableHeaderCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzioni} onChange={(e) => this.handleChangeData(0,e,"Attrezzature","Carroponte")} value={typeof this.state.dtAttrezzature[0] != "undefined"? (this.state.dtAttrezzature[0].Carroponte):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Carroponte" name="Carroponte" value={typeof this.state.dtAttrezzature[1] != "undefined"? (this.state.dtAttrezzature[1].Carroponte):""} onChange={(e) => this.handleChangeData(1,e,"Attrezzature")}/></CTableDataCell>
  
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Compressori</CTableHeaderCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzioni} onChange={(e) => this.handleChangeData(0,e,"Attrezzature","Compressori")} value={typeof this.state.dtAttrezzature[0] != "undefined"? (this.state.dtAttrezzature[0].Compressori):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Compressori" name="Compressori" value={typeof this.state.dtAttrezzature[1] != "undefined"? (this.state.dtAttrezzature[1].Compressori):""} onChange={(e) => this.handleChangeData(1,e,"Attrezzature")}/></CTableDataCell>
  
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Apparecchi Sollevamento</CTableHeaderCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzioni} onChange={(e) => this.handleChangeData(0,e,"Attrezzature","Apparecchi_Sollevamento")} value={typeof this.state.dtAttrezzature[0] != "undefined"? (this.state.dtAttrezzature[0].Apparecchi_Sollevamento):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Apparecchi_Sollevamento" name="Apparecchi_Sollevamento" value={typeof this.state.dtAttrezzature[1] != "undefined"? (this.state.dtAttrezzature[1].Apparecchi_Sollevamento):""} onChange={(e) => this.handleChangeData(1,e,"Attrezzature")}/></CTableDataCell>
  
    </CTableRow>
    
  </CTableBody>
</CTable>
<center><CButton onClick={(e) => this.updateData(e,"Attrezzature")}>Salva</CButton></center>
</CForm>
*/}
{/* Impianti */}
<h3>Impianti</h3> 
<CForm>
      <CTable bordered>
  <CTableHead>
    <CTableRow>
    
      <CTableHeaderCell scope="col">Descrizione</CTableHeaderCell>
      <CTableHeaderCell scope="col">Presente/Assente</CTableHeaderCell>
      <CTableHeaderCell scope="col">Conformità</CTableHeaderCell>
      <CTableHeaderCell scope="col">Note</CTableHeaderCell>
    </CTableRow>
  </CTableHead>
  <CTableBody>
    <CTableRow>
      <CTableHeaderCell scope="row">Elettrico</CTableHeaderCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzionImpianti} onChange={(e) => this.handleChangeData(0,e,"Impianti","Elettrico")} value={typeof this.state.dtImpianti[0] != "undefined"? (this.state.dtImpianti[0].Elettrico):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzioni} disabled={typeof this.state.dtImpianti[0] != "undefined"? (this.state.dtImpianti[0].Elettrico ==="Presente"?(false):(true)):("")} onChange={(e) => this.handleChangeData(1,e,"Impianti","Elettrico")} value={typeof this.state.dtImpianti[1] != "undefined"? (this.state.dtImpianti[1].Elettrico):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Elettrico" name="Elettrico" value={typeof this.state.dtImpianti[2] != "undefined"? (this.state.dtImpianti[2].Elettrico):""} onChange={(e) => this.handleChangeData(2,e,"Impianti")}/></CTableDataCell>
  
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Termico</CTableHeaderCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzionImpianti} onChange={(e) => this.handleChangeData(0,e,"Impianti","Termico")} value={typeof this.state.dtImpianti[0] != "undefined"? (this.state.dtImpianti[0].Termico):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzioni} disabled={typeof this.state.dtImpianti[0] != "undefined"? (this.state.dtImpianti[0].Termico ==="Presente"?(false):(true)):("")} onChange={(e) => this.handleChangeData(1,e,"Impianti","Termico")} value={typeof this.state.dtImpianti[1] != "undefined"? (this.state.dtImpianti[1].Termico):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Termico" name="Termico" value={typeof this.state.dtImpianti[2] != "undefined"? (this.state.dtImpianti[2].Termico):""} onChange={(e) => this.handleChangeData(2,e,"Impianti")}/></CTableDataCell>
  
    </CTableRow>
    
    <CTableRow>
      <CTableHeaderCell scope="row">Gas</CTableHeaderCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzionImpianti} onChange={(e) => this.handleChangeData(0,e,"Impianti","Gas")} value={typeof this.state.dtImpianti[0] != "undefined"? (this.state.dtImpianti[0].Gas):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzioni} disabled={typeof this.state.dtImpianti[0] != "undefined"? (this.state.dtImpianti[0].Gas ==="Presente"?(false):(true)):("")} onChange={(e) => this.handleChangeData(1,e,"Impianti","Gas")} value={typeof this.state.dtImpianti[1] != "undefined"? (this.state.dtImpianti[1].Gas):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Gas" name="Gas" value={typeof this.state.dtImpianti[2] != "undefined"? (this.state.dtImpianti[2].Gas):""} onChange={(e) => this.handleChangeData(2,e,"Impianti")}/></CTableDataCell>
  
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Condizionamento</CTableHeaderCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzionImpianti} onChange={(e) => this.handleChangeData(0,e,"Impianti","Condizionamento")} value={typeof this.state.dtImpianti[0] != "undefined"? (this.state.dtImpianti[0].Condizionamento):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzioni} disabled={typeof this.state.dtImpianti[0] != "undefined"? (this.state.dtImpianti[0].Condizionamento ==="Presente"?(false):(true)):("")} onChange={(e) => this.handleChangeData(1,e,"Impianti","Condizionamento")} value={typeof this.state.dtImpianti[1] != "undefined"? (this.state.dtImpianti[1].Condizionamento):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Condizionamento" name="Condizionamento" value={typeof this.state.dtImpianti[2] != "undefined"? (this.state.dtImpianti[2].Condizionamento):""} onChange={(e) => this.handleChangeData(2,e,"Impianti")}/></CTableDataCell>
  
    </CTableRow>  <CTableRow>
      <CTableHeaderCell scope="row">Vapore</CTableHeaderCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzionImpianti} onChange={(e) => this.handleChangeData(0,e,"Impianti","Vapore")} value={typeof this.state.dtImpianti[0] != "undefined"? (this.state.dtImpianti[0].Vapore):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzioni} disabled={typeof this.state.dtImpianti[0] != "undefined"? (this.state.dtImpianti[0].Vapore ==="Presente"?(false):(true)):("")} onChange={(e) => this.handleChangeData(1,e,"Impianti","Vapore")} value={typeof this.state.dtImpianti[1] != "undefined"? (this.state.dtImpianti[1].Vapore):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Vapore" name="Vapore" value={typeof this.state.dtImpianti[2] != "undefined"? (this.state.dtImpianti[2].Vapore):""} onChange={(e) => this.handleChangeData(2,e,"Impianti")}/></CTableDataCell>
  
    </CTableRow>  <CTableRow>
      <CTableHeaderCell scope="row">Aria Compressa</CTableHeaderCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzionImpianti} onChange={(e) => this.handleChangeData(0,e,"Impianti","Aria_Compressa")} value={typeof this.state.dtImpianti[0] != "undefined"? (this.state.dtImpianti[0].Aria_Compressa):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzioni} disabled={typeof this.state.dtImpianti[0] != "undefined"? (this.state.dtImpianti[0].Aria_Compressa ==="Presente"?(false):(true)):("")} onChange={(e) => this.handleChangeData(1,e,"Impianti","Aria_Compressa")} value={typeof this.state.dtImpianti[1] != "undefined"? (this.state.dtImpianti[1].Aria_Compressa):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Aria_Compressa" name="Aria_Compressa" value={typeof this.state.dtImpianti[2] != "undefined"? (this.state.dtImpianti[2].Aria_Compressa):""} onChange={(e) => this.handleChangeData(2,e,"Impianti")}/></CTableDataCell>
  
    </CTableRow>  <CTableRow>
      <CTableHeaderCell scope="row">Idrico</CTableHeaderCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzionImpianti} onChange={(e) => this.handleChangeData(0,e,"Impianti","Idrico")} value={typeof this.state.dtImpianti[0] != "undefined"? (this.state.dtImpianti[0].Idrico):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzioni} disabled={typeof this.state.dtImpianti[0] != "undefined"? (this.state.dtImpianti[0].Idrico ==="Presente"?(false):(true)):("")} onChange={(e) => this.handleChangeData(1,e,"Impianti","Idrico")} value={typeof this.state.dtImpianti[1] != "undefined"? (this.state.dtImpianti[1].Idrico):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Idrico" name="Idrico" value={typeof this.state.dtImpianti[2] != "undefined"? (this.state.dtImpianti[2].Idrico):""} onChange={(e) => this.handleChangeData(2,e,"Impianti")}/></CTableDataCell>
  
    </CTableRow>  <CTableRow>
      <CTableHeaderCell scope="row">Messa A Terra</CTableHeaderCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzionImpianti} onChange={(e) => this.handleChangeData(0,e,"Impianti","Messa_A_Terra")} value={typeof this.state.dtImpianti[0] != "undefined"? (this.state.dtImpianti[0].Messa_A_Terra):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzioni} disabled={typeof this.state.dtImpianti[0] != "undefined"? (this.state.dtImpianti[0].Messa_A_Terra ==="Presente"?(false):(true)):("")} onChange={(e) => this.handleChangeData(1,e,"Impianti","Messa_A_Terra")} value={typeof this.state.dtImpianti[1] != "undefined"? (this.state.dtImpianti[1].Messa_A_Terra):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Messa_A_Terra" name="Messa_A_Terra" value={typeof this.state.dtImpianti[2] != "undefined"? (this.state.dtImpianti[2].Messa_A_Terra):""} onChange={(e) => this.handleChangeData(2,e,"Impianti")}/></CTableDataCell>
  
    </CTableRow>  <CTableRow>
      <CTableHeaderCell scope="row">Denuncia Messa a Terra</CTableHeaderCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzionImpianti} onChange={(e) => this.handleChangeData(0,e,"Impianti","Denuncia_MAT")} value={typeof this.state.dtImpianti[0] != "undefined"? (this.state.dtImpianti[0].Denuncia_MAT):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzioni} disabled={typeof this.state.dtImpianti[0] != "undefined"? (this.state.dtImpianti[0].Denuncia_MAT ==="Presente"?(false):(true)):("")} onChange={(e) => this.handleChangeData(1,e,"Impianti","Denuncia_MAT")} value={typeof this.state.dtImpianti[1] != "undefined"? (this.state.dtImpianti[1].Denuncia_MAT):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Denuncia_MAT" name="Denuncia_MAT" value={typeof this.state.dtImpianti[1] != "undefined"? (this.state.dtImpianti[2].Denuncia_MAT):""} onChange={(e) => this.handleChangeData(2,e,"Impianti")}/></CTableDataCell>
  
    </CTableRow>  <CTableRow>
      <CTableHeaderCell scope="row">Verifica Periodica Messa A Terra</CTableHeaderCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzionImpianti} onChange={(e) => this.handleChangeData(0,e,"Impianti","Verifica_Periodica_MAT")} value={typeof this.state.dtImpianti[0] != "undefined"? (this.state.dtImpianti[0].Verifica_Periodica_MAT):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzioni} disabled={typeof this.state.dtImpianti[0] != "undefined"? (this.state.dtImpianti[0].Verifica_Periodica_MAT ==="Presente"?(false):(true)):("")} onChange={(e) => this.handleChangeData(1,e,"Impianti","Verifica_Periodica_MAT")} value={typeof this.state.dtImpianti[1] != "undefined"? (this.state.dtImpianti[1].Verifica_Periodica_MAT):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Verifica_Periodica_MAT" name="Verifica_Periodica_MAT" value={typeof this.state.dtImpianti[2] != "undefined"? (this.state.dtImpianti[2].Verifica_Periodica_MAT):""} onChange={(e) => this.handleChangeData(2,e,"Impianti")}/></CTableDataCell>
  
    </CTableRow>  <CTableRow>
      <CTableHeaderCell scope="row">Scariche Atmosferiche</CTableHeaderCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzionImpianti} onChange={(e) => this.handleChangeData(0,e,"Impianti","Scariche_Atmosferiche")} value={typeof this.state.dtImpianti[0] != "undefined"? (this.state.dtImpianti[0].Scariche_Atmosferiche):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzioni} disabled={typeof this.state.dtImpianti[0] != "undefined"? (this.state.dtImpianti[0].Scariche_Atmosferiche ==="Presente"?(false):(true)):("")} onChange={(e) => this.handleChangeData(1,e,"Impianti","Scariche_Atmosferiche")} value={typeof this.state.dtImpianti[1] != "undefined"? (this.state.dtImpianti[1].Scariche_Atmosferiche):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Scariche_Atmosferiche" name="Scariche_Atmosferiche" value={typeof this.state.dtImpianti[2] != "undefined"? (this.state.dtImpianti[2].Scariche_Atmosferiche):""} onChange={(e) => this.handleChangeData(2,e,"Impianti")}/></CTableDataCell>
  
    </CTableRow>
    <CTableRow>
      <CTableHeaderCell scope="row">Centrale Termica</CTableHeaderCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzionImpianti} onChange={(e) => this.handleChangeData(0,e,"Impianti","Centrale_Termica")} value={typeof this.state.dtImpianti[0] != "undefined"? (this.state.dtImpianti[0].Centrale_Termica):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell>
      <Dropdown options={this.state.opzioni} disabled={typeof this.state.dtImpianti[0] != "undefined"? (this.state.dtImpianti[0].Centrale_Termica ==="Presente"?(false):(true)):("")} onChange={(e) => this.handleChangeData(1,e,"Impianti","Centrale_Termica")} value={typeof this.state.dtImpianti[1] != "undefined"? (this.state.dtImpianti[1].Centrale_Termica):""} placeholder="Seleziona..." />
      </CTableDataCell>
      <CTableDataCell><CFormInput type="text" id="Centrale_Termica" name="Centrale_Termica" value={typeof this.state.dtImpianti[2] != "undefined"? (this.state.dtImpianti[2].Centrale_Termica):""} onChange={(e) => this.handleChangeData(2,e,"Impianti")}/></CTableDataCell>
  
    </CTableRow>
  </CTableBody>
</CTable>
<center><CButton onClick={(e) => this.updateData(e,"Impianti")}>Salva</CButton></center>
</CForm>



      </CAccordionBody>
    </CAccordionItem>
    <CAccordionItem itemKey={5} onClick={() => this.loadData("ValutazioneDeiRischi")}>
      <CAccordionHeader>
    VALUTAZIONE DEI RISCHI
      </CAccordionHeader>
      <CAccordionBody>
      <IconButton aria-label="print"  onClick={() => window.print()}>
<i class="bi bi-printer" style={{cursor:"pointer",width:"32px",height:"32px"}}></i>
      </IconButton>
          {/* Documenti di valutazione */}
      <h3>Documenti Di Valutazione</h3> 
<CForm>
      <CTable bordered>
  <CTableHead>
    <CTableRow>
    
      <CTableHeaderCell scope="col">Descrizione</CTableHeaderCell>
      <CTableHeaderCell scope="col">Applicabile</CTableHeaderCell>
      <CTableHeaderCell scope="col">Data Eleborazione</CTableHeaderCell>
      <CTableHeaderCell scope="col">Data Aggiornamento</CTableHeaderCell>
      <CTableHeaderCell scope="col">Firme</CTableHeaderCell>
      <CTableHeaderCell scope="col">Note</CTableHeaderCell>
    
    </CTableRow>
  </CTableHead>
  <CTableBody>



  { // CREAZIONE DELLA SEZIONE DOCUMENTO DI VALUTAZIONE
    this.state.vdrDocValutazione[0]!= undefined ? (
      
    Object.keys(this.state.vdrDocValutazione[0]).map((key) =>
    
    key=== "ID" || key === "ID_Checklist" || key === "Tipo_Record" ?
        ("")
      :
     <>
  
       
    <CTableRow key={key}>
      <CTableHeaderCell scope="row">
        {
          key.includes("_")?
              key.replaceAll("_"," ") //tolgo i trattini
            :
              key  
        }
        </CTableHeaderCell>
        <CTableDataCell>
         <Dropdown options={this.state.opzioni} onChange={(e) => this.handleChangeData(0,e,"DocumentoValutazione",key)} value={typeof this.state.vdrDocValutazione[0] != "undefined"? (this.state.vdrDocValutazione[0][key]):""} placeholder="Seleziona..." />
        </CTableDataCell>
        <CTableDataCell>
         <CFormInput type="text" id={key} name={key} value={typeof this.state.vdrDocValutazione[1] != "undefined"? (this.state.vdrDocValutazione[1][key]):""} onChange={(e) => this.handleChangeData(1,e,"DocumentoValutazione")}/>
        </CTableDataCell>
        <CTableDataCell>
          <CFormInput type="text" id={key} name={key} value={typeof this.state.vdrDocValutazione[2] != "undefined"? (this.state.vdrDocValutazione[2][key]):""} onChange={(e) => this.handleChangeData(2,e,"DocumentoValutazione")}/>
        </CTableDataCell>
        <CTableDataCell>
          <FormControlLabel control={<Checkbox name={key}  checked={this.state.vdrDocValutazione[3][key].split("-")[0]==="1"?true:false} onChange={(e) =>this.handleCboxChange(e,0) } />} label="Datore di lavoro" /> <br/>
          <FormControlLabel control={<Checkbox name={key} checked={this.state.vdrDocValutazione[3][key].split("-")[1]==="1"?true:false}  onChange={(e) =>this.handleCboxChange(e,1) } />} label="Medico competente" /><br/>
          <FormControlLabel control={<Checkbox name={key} checked={this.state.vdrDocValutazione[3][key].split("-")[2]==="1"?true:false}  onChange={(e) =>this.handleCboxChange(e,2) } />} label="RLS" /><br/>
          <FormControlLabel control={<Checkbox name={key} checked={this.state.vdrDocValutazione[3][key].split("-")[3]==="1"?true:false} onChange={(e) =>this.handleCboxChange(e,3) } />} label="RSPP" />
        </CTableDataCell>
        <CTableDataCell>
          <CFormInput type="text" id={key} name={key}  value={typeof this.state.vdrDocValutazione[4][key] != "undefined"? (this.state.vdrDocValutazione[4][key]):""} onChange={(e) => this.handleChangeData(4,e,"DocumentoValutazione")}/>
        </CTableDataCell>
     </CTableRow>
 </>
 )):""

 }



    
  </CTableBody>
</CTable>
<center><CButton onClick={(e) => this.updateData(e,"DocumentoValutazione")}>Salva</CButton></center>
</CForm>


    {/* Rischi */}
    <h3>Rischi</h3> 
   
      <CTable bordered>

  <CTableBody>


  {
    this.state.vdrRischi[0]!= undefined ? (
      
    Object.keys(this.state.vdrRischi[0]).map((key) =>
    
    key=== "ID" || key === "ID_Checklist" || key === "Tipo_Record" || key === "Mansione"?
        ("")
      :
     <>
  
        <CTableRow key={key}><CTableHeaderCell scope="row" colSpan="7" style={{backgroundColor:"#39f",color:"white"}}>
        {
          key.includes("_")?
              key.replaceAll("_"," ")
            :
              key  
        }
        </CTableHeaderCell></CTableRow>
        <CTableRow >
    
    <CTableHeaderCell scope="col" >Mansione</CTableHeaderCell>
    <CTableHeaderCell scope="col" >DPI</CTableHeaderCell>
    <CTableHeaderCell scope="col" >Probabilità</CTableHeaderCell>
    <CTableHeaderCell scope="col" >Gravità</CTableHeaderCell>
    <CTableHeaderCell scope="col" >Rischio</CTableHeaderCell>
    <CTableHeaderCell scope="col" >Note</CTableHeaderCell>
 
  
  
  </CTableRow>
        {
          
        this.state.vdrRischi?.map((rischio,index) => {
       
          
        if( index % 4 === 0 ) {
          let rischioTotale =this.state.vdrRischi[index+2][key]*this.state.vdrRischi[index+1][key];
         
          return (
            <CTableRow key={rischio.ID}><CTableDataCell>
            <p>{rischio.Mansione}</p>
            </CTableDataCell>
            <CTableDataCell>
            {/*<Dropdown options={this.state.livelloRischio} onChange={(e) => this.handleChangeData(index,e,"Rischi",key)} value={typeof rischio[key] != "undefined"? (rischio[key]):""} placeholder="Seleziona..." /> */}

            <Modal myFunction={this.inputFromCBoxModal}
title="Modifica"
tipologia="Rischi"
data={{items:[],
  dpi:this.state.dpi,
  currentDpi:this.state.vdrRischi[index][key].split("-"),
  name:key,
  index:index}}


/>
            </CTableDataCell>
        
            
                <CTableDataCell>
             
                <Dropdown options={["1","2","3","4"]} onChange={(e) => this.handleChangeData(index+1,e,"Rischi",key)} value={typeof this.state.vdrRischi[index+1][key] != "undefined"? (this.state.vdrRischi[index+1][key]):""} placeholder="Seleziona..." />
        
               </CTableDataCell>
               <CTableDataCell>
               <Dropdown options={["1","2","3","4"]} onChange={(e) => this.handleChangeData(index+2,e,"Rischi",key)} value={typeof this.state.vdrRischi[index+2][key] != "undefined"? (this.state.vdrRischi[index+2][key]):""} placeholder="Seleziona..." />
               
        
               </CTableDataCell>
               <CTableDataCell >
                <CFormInput value={typeof this.state.vdrRischi[index+2][key] != "undefined"? (rischioTotale===0 || rischioTotale ===NaN? "":(rischioTotale === 1? "LIEVE": (rischioTotale <= 4?"BASSO":(rischioTotale <= 8?"MEDIO":"ALTO")))):""} readOnly={true} className={rischioTotale===0 || rischioTotale ===NaN? "": rischioTotale === 1? "LIEVE": (rischioTotale <= 4?"BASSO":(rischioTotale <= 8?"MEDIO":"ALTO"))}/>
               
               
               </CTableDataCell>
               <CTableDataCell>
                <CFormTextarea style={{height:"38px"}}  type="text" id={key} name={key} value={typeof this.state.vdrRischi[index+3][key] != "undefined"? (this.state.vdrRischi[index+3][key]):""} onChange={(e) => this.handleChangeData(index+3,e,"Rischi")}/>
               
        
               </CTableDataCell>
               </CTableRow>)
        }
     
      
      })
        
        }

<CTableRow >
 
  <CTableDataCell colSpan="7"><center><CButton onClick={(e) => this.updateData(e,"Rischi")}>Salva</CButton></center></CTableDataCell>
 
</CTableRow>
 </>
 

      
  

      )
    
    
    ):""
 
 
    
 }



 
    
  
</CTableBody>

</CTable>

      </CAccordionBody>
    </CAccordionItem>
  </CAccordion></div>
);
}
}

function WithNavigate(props) {
  const location = useLocation();

  return <Checklist {...props} location={location} />;
}

export default WithNavigate